module.exports = __webpack_public_path__ + "img/9788960177123.9d9f3b5d.jpg";